import {html} from 'lit';
import InputText from './input-text.js';
import '../text/text-l.js';
import '../text/text-s.js';
import styles from './input-radio.css' assert {type: 'css'};

/**
 * @element inv-input-radio
 *
 * @class InputRadio
 * @extends InputText
 * @classdesc InputRadio component
 *
 * @cssproperty --inv-input-radio-checked-outline-color
 * @description the outline color for the checked radio button
 * @type {string}
 * @default "#0e4dab"
 *
 * @cssproperty --inv-input-radio-focus-border-color
 * @description the border color for the focused radio button
 * @type {string}
 * @default "#0e4dab"
 */

export default class InputRadio extends InputText {
    constructor() {
        super();
        this.type = 'radio';
        this.value = 1;
        this.name = 'radio';
        this.iconWidth = '2.66666em';
        this.iconHeight = '2.66666em';
        this.title = 'Title';
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    renderInput() {
        const nodes = [
            html`
                <div class="radio-icon-container">${this.renderIcon()}</div>
            `,

            html`
                <inv-text-l class="radio-title">${this.title}</inv-text-l>
            `,
        ];

        if (this.subtitle) {
            nodes.push(
                html`
                    <inv-text-s class="radio-subtitle">${this.subtitle}</inv-text-s>
                `
            );
        }
        const childNode = html`
            <label for="${this.value}" class="text-container ${this.disabled && 'disabled'}">${nodes}</label>
        `;
        return super.renderInput(childNode);
    }

    renderContent() {
        return this.renderInput();
    }

    static get properties() {
        return {
            ...super.properties,
            icon: {
                type: String,
            },
            subtitle: {
                type: String,
            },
            value: {
                type: String,
            },
            title: {
                type: String,
            },
        };
    }
}
InputRadio.register();
